(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function prepareMarquee(section) {
    if (section.dataset.mediaReady === 'true') return;
    section.dataset.mediaReady = 'true';

    var marquee = section.querySelector('.index-media__marquee');
    var group = section.querySelector('[data-index-media-group]');
    if (!marquee || !group) return;

    if (reduceMotion.matches) return;

    var clone = group.cloneNode(true);
    clone.removeAttribute('data-index-media-group');
    clone.setAttribute('aria-hidden', 'true');

    clone.querySelectorAll('a').forEach(function (link) {
      link.setAttribute('tabindex', '-1');
    });

    clone.querySelectorAll('img').forEach(function (img) {
      img.alt = '';
      img.setAttribute('alt', '');
      img.setAttribute('loading', 'lazy');
      img.setAttribute('decoding', 'async');
      img.setAttribute('fetchpriority', 'low');
    });

    marquee.appendChild(clone);
  }

  function setInView(section, inView) {
    if (reduceMotion.matches) {
      section.classList.remove('index-media--in-view');
      return;
    }

    if (inView) {
      prepareMarquee(section);
      section.classList.add('index-media--in-view');
    } else {
      section.classList.remove('index-media--in-view');
    }
  }

  function bindSection(section) {
    if (section.dataset.mediaBound === 'true') return;
    section.dataset.mediaBound = 'true';

    if (!('IntersectionObserver' in window)) {
      prepareMarquee(section);
      setInView(section, true);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          setInView(section, entry.isIntersecting);
        });
      },
      { rootMargin: '200px 0px', threshold: 0.01 }
    );

    observer.observe(section);
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var sections = scope.querySelectorAll
      ? scope.querySelectorAll('[data-index-media]')
      : [];

    if (!sections.length && scope.hasAttribute && scope.hasAttribute('data-index-media')) {
      sections = [scope];
    }

    for (var i = 0; i < sections.length; i += 1) {
      bindSection(sections[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  if (typeof reduceMotion.addEventListener === 'function') {
    reduceMotion.addEventListener('change', function () {
      document.querySelectorAll('[data-index-media]').forEach(function (section) {
        section.dataset.mediaReady = '';
        section.dataset.mediaBound = '';
        var clone = section.querySelector('.index-media__group[aria-hidden="true"]');
        if (clone) clone.remove();
        bindSection(section);
      });
    });
  }
})();
